/**
 * Image Parallax Effect
 * Subtle parallax effect for block images on scroll
 */

function initParallax(selector, initialOffset = 0) {
	const imageContainer = document.querySelector(selector);
	
	if (!imageContainer) {
		return;
	}

	const img = imageContainer.querySelector('img');
	if (!img) {
		return;
	}

	let ticking = false;
	const parallaxSpeed = 0.15; // Very subtle - 15% of scroll distance

	function updateParallax() {
		const rect = imageContainer.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		
		// Only apply parallax when image is in viewport
		if (rect.bottom < 0 || rect.top > windowHeight) {
			img.style.transform = `translateY(${initialOffset}px)`;
			ticking = false;
			return;
		}

		// Calculate parallax offset
		// When image is at top of viewport, offset is initialOffset
		// As it scrolls, move image up slightly
		const imageCenter = rect.top + rect.height / 2;
		const viewportCenter = windowHeight / 2;
		const distanceFromCenter = imageCenter - viewportCenter;
		const offset = initialOffset + (distanceFromCenter * parallaxSpeed);

		img.style.transform = `translateY(${offset}px)`;
		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			window.requestAnimationFrame(updateParallax);
			ticking = true;
		}
	}

	// Initial calculation
	updateParallax();

	// Throttled scroll handler
	window.addEventListener('scroll', onScroll, { passive: true });
	
	// Recalculate on resize
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(updateParallax, 150);
	}, { passive: true });
}

function initContactParallax() {
	// Respect reduced motion preference
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return;
	}

	// Disable on mobile devices
	if (window.innerWidth <= 991) {
		return;
	}

	initParallax('.contact-block__image');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initContactParallax);
} else {
	initContactParallax();
}

export default initContactParallax;



